/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 分享链接（用于生成小程序或H5的二维码）
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.ShareEndpoint>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/share-endpoints`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
